import { StatusEnum } from '@/enum/status.enum.js'

export const OptionDropdownStatus = [
  { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
  { text: StatusEnum.INACTIVE, value: StatusEnum.INACTIVE },
  { text: StatusEnum.DELETE, value: StatusEnum.DELETE },
]

export const OptionStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.INACTIVE,
  StatusEnum.DELETE,
]

export const OptionCheckboxStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.INACTIVE,
  StatusEnum.PENDING,
  StatusEnum.DELETE,
]

export const OptionCheckboxClientAppsStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.INACTIVE,
]

export const OptionCheckboxTechProductsStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.INACTIVE,
]

export const OptionDropdownCatalogStatus = [
  { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
  { text: StatusEnum.INACTIVE, value: StatusEnum.INACTIVE },
  { text: StatusEnum.DELETE, value: StatusEnum.DELETE },
  { text: StatusEnum.PENDING, value: StatusEnum.PENDING },
]

export const OptionCheckboxPromotionStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.COMPLETE,
  StatusEnum.EXPIRE,
  StatusEnum.DELETE,
]

export const OptionCheckboxChannelStatus = [
  StatusEnum.ACTIVE,
  StatusEnum.DELETE,
]
